import FeatureGates from "@atlassian/feature-gate-js-client";

import { ConfluenceSoftwarePageProps } from "../../../pages/confluence/confluence-software-page";

import { ConfluenceSoftwarePage } from "./confluence-software-page";
import { ConfluenceSoftwarePageCfind1234 } from "./confluence-software-variant-cfind-1234";

export const ConfluenceSoftwarePageTemplate = (
    props: ConfluenceSoftwarePageProps
) => {
    const productTourRefreshEnrollment = FeatureGates.getExperimentValue(
        "cfind-1234-product-tour-refresh-q3fy24",
        "enrolled",
        false
    );
    return productTourRefreshEnrollment ? (
        <ConfluenceSoftwarePageCfind1234 {...props} />
    ) : (
        <ConfluenceSoftwarePage {...props} />
    );
};
